import { BaseService } from './../base'

export class TypeRemitentService extends BaseService {
  static get entity () {
    return 'type_remitent'
  }
  static get name () {
    return 'type_remitent'
  }
}